import { render } from '@axilon-apps/domains-ontology-ui-main'

render()
